import { statementPaymentInitialValue } from '@/@types/statement/statementPayment';

export default {
  statementPayment: statementPaymentInitialValue,
};
